<template lang="pug">
    div.fluid.ma-0.pa-0.fill-height
        .pa-md-4.brown.lighten-5(style="height: 100vh;")
            .text-center(v-if="isLoading")
                v-progress-circular(
                    :size='100'
                    :width='10'
                    color='var(--volie-blue)'
                    indeterminate
                    style="margin-top: 100px;"
                )

            NoLoggedInQueues(
                v-else-if="renderNoLoggedInQueues"
            )

            NoCurrentCustomer(
                v-else-if="renderNoCurrentCustomer"
                text="We will send you a customer as soon as a new conversation becomes available"
                communication-type="SMS Message"
                :organization-users="organizationUsers"
            )

            div(v-else)
                div(v-if="mainErrorAlert.show" style="margin-top: 2%;")
                    v-alert(type="error")
                        | {{ mainErrorAlert.text }}

                div(v-else)
                    v-row(dense style="height: 100vh;" ref="smsMessageContentRow")
                        v-col(cols='12' md='8')
                            CustomerProfile.pa-2(
                                v-if="validCampaignCustomerActiveID"
                                v-bind:style="{ height: customerProfileHeight + 'px' }"
                                :appointment-is-unique-if-required="appointmentIsUniqueIfRequired"
                                :audio-email-incoming="audioEmailIncoming"
                                :audio-email-outcoming="audioEmailOutcoming"
                                communication-type="SMS Message"
                                :complete-campaign-customer-active="completeCampaignCustomerActive"
                                :communication-manager="communicationManager"
                                :create-agent="createAgent"
                                :current-campaign-customer="currentCampaignCustomer"
                                :customer-profile-height="customerProfileHeight"
                                :handle-update-current-campaign-customer="handleUpdateCurrentCampaignCustomer"
                                :is-acknowledgeable="isAcknowledgeable"
                                :in-communication-center="true"
                                :is-rac-online="isRacOnline"
                                :organization-users="organizationUsers"
                                :set-appointment-is-unique-if-required="setAppointmentIsUniqueIfRequired"
                                :set-change-on-current-campaign-customer="setChangeOnCurrentCampaignCustomer"
                                :set-is-okay-to-create-communication-disposition="setIsOkayToCreateCommunicationDisposition"
                                :show-snackbar="showSnackbar"
                                :set-communication-manager="setCommunicationManager"
                                :set-selected-campaign-disposition="setSelectedCampaignDisposition"
                                :unassign-campaign-customer-active="unassignCampaignCustomerActive"
                                source="communication_center"
                            )
                            CustomerSearchCreate(
                                v-else-if="validCampaignID"
                                v-bind:style="{ height: customerProfileHeight + 'px' }"
                                communication-type="SMS Message"
                                :current-campaign="currentCampaign"
                                :current-campaign-customer="currentCampaignCustomer"
                                :card-height="customerProfileHeight"
                                :create-agent="createAgent"
                                enrollment-purpose="return_message"
                                :force-customer="forceCustomer"
                                :initiate-create-communication-disposition="initiateCreateCommunicationDisposition"
                                :is-manual-mode="isManualMode"
                                :new-enrollment-success="newEnrollmentSuccess"
                                :set-is-okay-to-create-communication-disposition="setIsOkayToCreateCommunicationDisposition"
                                :set-selected-campaign-disposition="setSelectedCampaignDisposition"
                                :show-snackbar="showSnackbar"
                            )

                        v-col(cols='6' md='4')
                            AssignedSummary.no-padding(
                                :campaign-customers="campaignCustomers"
                                :change-campaign-customers="changeCampaignCustomers"
                                :set-sms-message-total-assigned-unresponded-to-customers="setSmsMessageTotalAssignedUnrespondedToCustomers"
                                v-if="!validForceCampaignCustomer"
                            )

                            Softphone.pa-2(
                                v-bind:style="{ height: softphoneHeight + 'px' }"
                                :account-id="currentCampaignCustomer.account_id"
                                :create-agent="createAgent"
                                :current-campaign-customer="currentCampaignCustomer"
                                :is-acknowledgeable="isAcknowledgeable"
                                :is-rac-online="isRacOnline"
                                :is-update-communication-response-status-loading="isUpdateCommunicationResponseStatusLoading"
                                :play-incoming-message-audio="playIncomingMessageAudio"
                                :show-snackbar="showSnackbar"
                                :soft-phone-height="softphoneHeight"
                                :update-communication-response-status-for-message-unresponded="updateCommunicationResponseStatusForMessageUnresponded"
                            )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import AssignedSummary from '@/components/communication_center/sms_message/assigned_summary.vue';
    import CustomerProfile from '@/components/communication_center/shared/customer_profile.vue';
    import CustomerSearchCreate from '@/components/communication_center/shared/customer_search_create.vue';
    import NoCurrentCustomer from '@/components/communication_center/shared/no_current_customer.vue';
    import NoLoggedInQueues from '@/components/communication_center/shared/no_logged_in_queues.vue';
    import Softphone from '@/components/communication_center/sms_message/softphone.vue';

    // Data
    import {
        AssignReadyCampaignCustomers,
        ReadAllConversationGroupUnreadMessages,
        UpdateCampaignCustomerActive,
        UpdateCommunicationResponseStatusForMessageUnresponded
    } from "@/data";

    // Helpers
    import { UpdateAssignedCustomerFromCustomerCommunicationManager } from "@/helpers/customer";
    import { applyIncomingTotalCommunicationDispositions } from "@/helpers/dispositions";

    export default Vue.extend({
        data() {
            return {
                appointmentIsUniqueIfRequired: true,
                bus: VolieState.websocketClient().eventBus(),
                campaignCustomers: [],
                communicationManager: null,
                contentRowHeight: null,
                currentCampaign: null,
                currentCampaignCustomer: null,
                customerProfileHeight: null,
                isAcknowledgeable: false,
                incomingMessageAudio: null,
                isManualMode: false,
                isLoading: false,
                isOkayToCreateCommunicationDisposition: false,
                isUpdatingCCActive: false,
                isUpdateCommunicationResponseStatusLoading: false,
                mainErrorAlert: {},
                manualModeCampaign: null,
                outgoingMessageAudio: null,
                selectedCampaignDisposition: null,
                softphoneHeight: null,
            }
        },
        methods: {
            assignReadyCampaignCustomers(skipLoading) {

                // If the current user isn't logged into any queues, no need to run this request
                if (!this.hasLoggedInQueues) {
                    this.mainErrorAlert.show = true;
                    this.mainErrorAlert.text = "Please log into one or more communication queues to get started";
                    return;
                }

                const options = {
                    communication_type_name: "SMS Message",
                    purpose: "return_message",
                }

                // Only load if necessary
                if (!skipLoading) {
                    this.isLoading = true;
                }

                AssignReadyCampaignCustomers(options).then((response) => {
                    if (!!response.Data && !!response.Data.campaign_customers && response.Data.campaign_customers.length > 0) {
                        this.campaignCustomers = this.sortCampaignCustomersByLastMessageId(response.Data.campaign_customers);
                        this.findOrSetInProgressCampaignCustomer();
                    } else {
                        this.isLoading = false;
                        this.campaignCustomers = [];
                        this.createAgentForAvailable();
                    }
                });

                return;
            },
            changeCampaignCustomers(otherCC) {

                // If the other record isn't the same as the current record, set record as current and update
                if (otherCC?.campaign_customer_active_id !== this.currentCampaignCustomer?.campaign_customer_active_id && otherCC.status === "assigned") {

                    // Set as current
                    this.currentCampaignCustomer = otherCC;

                    // Init options
                    const options = {
                        campaign_customer_active_id: this.currentCampaignCustomer.campaign_customer_active_id,
                        account_id: this.currentCampaignCustomer.account_id,
                        status: "in_progress",
                    }

                    // Update record in db
                    this.updateCampaignCustomerActive(options);
                }

                return;
            },
            cleanupUnreadMessageIDs(conversationGroup) {
                if (!conversationGroup || !(conversationGroup?.conversation_group_id > 0)) {
                    return;
                }

                // If null, set to empty array and abort
                if (conversationGroup.unread_message_ids === null) {
                    conversationGroup.unread_message_ids = [];
                    return;
                }

                // Unique array
                conversationGroup.unread_message_ids = conversationGroup.unread_message_ids.filter((v, i, a) => a.indexOf(v) === i);

                // Sort array
                conversationGroup.unread_message_ids = conversationGroup.unread_message_ids.sort(function(x, y){
                    return x - y;
                });

                return;
            },
            completeCampaignCustomerActive() {
                // Init options
                const options = {
                    campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id,
                    account_id: this.currentCampaignCustomer?.account_id,
                    status: "completed",
                }

                // Update record in db
                this.updateCampaignCustomerActive(options);
            },
            createAgentForAvailable() {
                if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                    return;
                }

                const options = {
                    status_name: "SMS Message - Available",
                }

                this.createAgent(options);
            },
            createAgentForCompletedCustomer() {
                if (!(this.currentCampaignCustomer?.campaign_customer_active_id > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    noticeable_id: this.currentCampaignCustomer.campaign_customer_id,
                    noticeable_type: "campaign_customer",
                    organization_id: this.currentCampaignCustomer.organization_id,
                    status_name: "SMS Message - Completed Customer",
                    immediately_move_to_status: null,
                }

                // Move back to logged in this way so the records get created in order
                if (this.validForceCampaignCustomer) {
                    options.immediately_move_to_status = "Logged In";
                }

                this.createAgent(options);
            },
            createAgentForJoinedConversation() {
                if (!(this.currentCampaignCustomer?.campaign_customer_active_id > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    noticeable_id: this.currentCampaignCustomer.campaign_customer_id,
                    noticeable_type: "campaign_customer",
                    organization_id: this.currentCampaignCustomer.organization_id,
                    status_name: "SMS Message - Joined Conversation",
                }

                this.createAgent(options);

                // If the current campaign customer has unread messages, mark them as read
                if (this.assignedHasUnreadMessages) {
                    this.readAllConversationGroupUnreadMessages(this.currentCampaignCustomer?.conversation_group?.conversation_group_id, this.currentCampaignCustomer?.conversation_group?.account_id);
                }
            },
            createAgentForPause() {
                const options = {
                    status_name: "Pause",
                }

                this.createAgent(options);
            },
            createAgentForSavedForLater() {
                if (!(this.currentCampaignCustomer?.campaign_customer_active_id > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    noticeable_id: this.currentCampaignCustomer.campaign_customer_id,
                    noticeable_type: "campaign_customer",
                    organization_id: this.currentCampaignCustomer.organization_id,
                    status_name: "SMS Message - Saved For Later",
                    immediately_move_to_status: null,
                }

                // Move back to logged in this way so the records get created in order
                if (this.validForceCampaignCustomer) {
                    options.immediately_move_to_status = "Logged In";
                }

                this.createAgent(options);
            },
            ensureOtherCampaignCustomersBackToAssigned() {
                if (!this.currentCampaignCustomer || !(this.campaignCustomers && this.campaignCustomers.length > 0)) {
                    return false;
                }

                for (let i = 0; i < this.campaignCustomers.length; i++) {

                    const other = this.campaignCustomers[i];
                    if (other?.campaign_customer_active_id !== this.currentCampaignCustomer.campaign_customer_active_id && other?.status === "in_progress") {
                        other.status = "assigned";
                    }
                }

                return true;
            },
            enterManualMode(campaign) {

                // Verify
                if (!(campaign?.campaign_id > 0)) {
                    return;
                }

                // Set manual mode fields
                this.currentCampaign = campaign;
                this.isManualMode = true;
                this.currentCampaignCustomer = null;
                this.saveAndNextAction = null;
                this.resetCurrentCampaignCustomerDefaults(false);

                // Create a cache of the manual mode campaign in case where user switches between inbound and manual mode
                // Needs to be a separate reference because currentCampaign gets reset to null via inbound
                this.manualModeCampaign = { ...campaign };

                // Run in next tick so screen resets properly
                Vue.nextTick(() => {

                    // Reinit current cc with temp object
                    this.currentCampaignCustomer = {
                        campaign_customer_active_id: null,
                        account_id: this.currentCampaign.account_id,
                        assigned_to: null,
                        campaign_customer_id: null,
                        campaign_id: this.currentCampaign.campaign_id,
                        current_scheduled_communication_id: null,
                        customer_id: null,
                        customer_vehicle_id: null,
                        forte_crm_key_id: null,
                        gm_ro_bac_is_valid: null,
                        inline_crm_key: null,
                        next_attemptable_id: null,
                        next_attemptable_type: null,
                        noticeable_id: null,
                        noticeable_type: null,
                        organization_id: this.currentCampaign.organization_id,
                        organization_time_zone_id: this.currentCampaign.organization_time_zone_id,
                        account_forte_crm_enabled: false,
                        account_inline_crm_enabled: false,
                        campaign_name: this.currentCampaign.campaign_name,
                        enrolled_date: null,
                        expiration_code: null,
                        next_attemptable_value: null,
                        next_attempt_number: null,
                        organization_name: this.currentCampaign.organization_name,
                        prospect_id: null,
                        purpose: "return_message",
                        status: null,
                        total_communication_dispositions: 0,
                        mykaarma_enabled: false,
                        tekion_enabled: false,
                        toyoguard_enabled: false,
                        user_email: null,
                        user_first_name: null,
                        user_last_name: null,
                        conversation_group: null,
                        customer: null,
                        incoming_phone_number: { ...this.currentCampaign.incoming_phone_number },
                        vin_enabled: false,
                        xtime_enabled: false,
                    }

                    // Move agent into manual message status
                    // this.createAgentForStartManualMessage();

                    // Stop loader
                    this.isLoading = false;

                    // Resize window
                    Vue.nextTick(() => {
                        this.handleWindowResize();
                    });
                });
            },
            exitManualMode() {

                // Unassign if someone is in scope
                if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                    this.unassignCampaignCustomerActive(true);
                }

                this.currentCampaign = null;
                this.manualModeCampaign = null;
                this.isManualMode = false;
                this.currentCampaignCustomer = null;
                this.resetCurrentCampaignCustomerDefaults(false);

                // Reinit screen
                this.getNext();
            },
            executeRemainingCreatedActions() {
                 // If force is present, set and init screen
                if (this.validForceCampaignCustomer) {

                    // Set as current
                    this.currentCampaignCustomer = { ...this.forceCampaignCustomer };

                    // Join conversation
                    this.createAgentForJoinedConversation();

                } else {

                    // Load normal screen
                    this.getNext();
                }
            },
            findOrSetInProgressCampaignCustomer() {
                if (!(!!this.campaignCustomers && this.campaignCustomers.length > 0)) {
                    return;
                }

                // Loop through campaign customers
                for (let i = 0; i < this.campaignCustomers.length; i++) {

                    // Init campaign customer
                    const campaignCustomer = this.campaignCustomers[i];

                    // If the status is present, set as current
                    if (!this.currentCampaignCustomer && campaignCustomer?.account_id > 0 && campaignCustomer?.campaign_customer_active_id > 0 && campaignCustomer?.status === 'in_progress') {

                        // Set
                        this.currentCampaignCustomer = campaignCustomer;

                        break;
                    }
                }

                // If zero in progress records in array, take the first record and mark it as in progress
                if (!this.currentCampaignCustomer) {

                    // Set campaign customer on data
                    this.currentCampaignCustomer = this.campaignCustomers[0];

                    // Update campaign customer to 'in progress'
                    this.updateCampaignCustomerActive({ account_id: this.currentCampaignCustomer?.account_id, campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id, status: "in_progress" });
                } else {

                    // Set isLoading back to false since we already have our current campaign customer
                    this.isLoading = false;
                    this.createAgentForJoinedConversation();
                }

                return;
            },
            getNext() {
                return this.isManualMode ? this.enterManualMode(this.manualModeCampaign) : this.assignReadyCampaignCustomers(false);
            },
            handleAfterCampaignCustomerActive(ccActiveID, skipAgentCreateInForce, skipAssignLoading) {

                // If present, handle
                if (ccActiveID > 0) {

                    // This will not be present when doing a force campaign customer via the manager live dashboard
                    if (this.campaignCustomers?.length > 0) {

                        // Find idx
                        const idx = this.campaignCustomers.findIndex(i => i.campaign_customer_active_id === ccActiveID);
                        if (idx >= 0) {

                            // Remove from slice
                            this.campaignCustomers.splice(idx, 1);
                        }
                    }

                    // Determine if we need to reinit
                    if (this.currentCampaignCustomer?.campaign_customer_active_id > 0 && this.currentCampaignCustomer?.campaign_customer_active_id === ccActiveID) {
                        this.currentCampaignCustomer = null;
                    }
                }

                // If came from vMessage, return
                if (this.validForceCustomer && this.validEndForceCustomer) {
                    return this.endForceCustomer();
                }

                // If we were here for a single record, return. Otherwise assign next
                return this.validForceCampaignCustomer ? this.exitForceCampaignCustomer(skipAgentCreateInForce) : this.assignReadyCampaignCustomers(skipAssignLoading);
            },
            handleUpdateCurrentCampaignCustomer(options) {

                // Verify same customer
                if (!(options?.customer_id > 0 && options.customer_id === this.currentCampaignCustomer?.customer?.customer_id)) {
                    return;
                }

                // Set customer params
                this.currentCampaignCustomer.customer = UpdateAssignedCustomerFromCustomerCommunicationManager(options, this.currentCampaignCustomer.customer);

                return;
            },
            handleWindowResize() {

                // Declare constants
                const assignedSummaryPx = 64;
                const paddingPx = 32;
                const topHeader = 64;

                // Calcuate
                this.contentRowHeight = this.$refs.smsMessageContentRow?.clientHeight - topHeader;
                this.customerProfileHeight = this.contentRowHeight - paddingPx;

                // Set softphone height
                if (this.validForceCampaignCustomer) {
                    this.softphoneHeight = this.customerProfileHeight
                } else {
                    this.softphoneHeight = this.customerProfileHeight - assignedSummaryPx;
                }
            },
            hasCampaignCustomerActive(ccActiveID) {

                // Verify
                if (!ccActiveID) {
                    return false;
                }

                // Verify that the current user either has it as the "current campaign customer" or has it in it's assigned slice
                if (this.currentCampaignCustomer?.campaign_customer_active_id > 0 && this.currentCampaignCustomer?.campaign_customer_active_id === ccActiveID) {
                    return true;
                }

                // This will not be present when doing a force campaign customer via the manager live dashboard
                if (this.campaignCustomers?.length > 0) {

                    // Find idx
                    const idx = this.campaignCustomers.findIndex(i => i.campaign_customer_active_id === ccActiveID);
                    if (idx >= 0) {
                        return true;
                    }
                }

                return false;
            },
            initMainErrorAlert() {
                this.mainErrorAlert = {
                    show: false,
                    text: null,
                }
            },
            loadMessageAudios() {
                if (import.meta.env.VITE_APP_SYSTEM_INCOMING_MESSAGE_AUDIO?.length > 0) {
                    this.incomingMessageAudio = new Audio(import.meta.env.VITE_APP_SYSTEM_INCOMING_MESSAGE_AUDIO);
                }
                if (import.meta.env.VITE_APP_SYSTEM_OUTGOING_MESSAGE_AUDIO?.length > 0) {
                    this.outgoingMessageAudio = new Audio(import.meta.env.VITE_APP_SYSTEM_OUTGOING_MESSAGE_AUDIO);
                }
            },
            matchMessageToConversationGroup(message) {

                // Init
                const match = {
                    belongsToCurrentAssigned: false,
                    conversationGroup: null,
                }

                // Verify message
                if (!message || !(message.account_id > 0) || !(message.conversation_group_id > 0) || !(message.conversation_group_person_id > 0) || !(this.campaignCustomers?.length > 0)) {
                    return null;
                }

                // Determine if the customer message belongs to one of the assigned campaign customers
                for (let i = 0; i < this.campaignCustomers.length; i++) {

                    // Init cc
                    const campaignCustomer = this.campaignCustomers[i];

                    // Determine if message's group matches this campaign customer
                    if (campaignCustomer?.campaign_customer_active_id > 0 && campaignCustomer?.conversation_group?.conversation_group_id > 0 && campaignCustomer?.conversation_group?.conversation_group_id === message.conversation_group_id) {
                        match.conversationGroup = campaignCustomer.conversation_group;

                        // Double check if this message belongs to the currenly assigned customer
                        if (this.currentCampaignCustomer?.campaign_customer_active_id === campaignCustomer.campaign_customer_active_id) {
                            match.belongsToCurrentAssigned = true;
                        }

                        break;
                    }
                }

                if (match?.conversationGroup?.conversation_group_id > 0) {
                    return match;
                }

                return null;
            },
            moveCampaignCustomerActiveToInProgress() {

                // Verify legit cc active and that we aren't already in progress status
                if (!(this.currentCampaignCustomer?.campaign_customer_active_id > 0) || this.currentCampaignCustomer.status === "in_progress") {
                    return;
                }

                // Init options
                const options = {
                    campaign_customer_active_id: this.currentCampaignCustomer.campaign_customer_active_id,
                    account_id: this.currentCampaignCustomer.account_id,
                    status: "in_progress",
                }

                // Update record in db
                this.updateCampaignCustomerActive(options, true);
            },
            newEnrollmentSuccess(ccActive, skipStatusMove) {

                // Verify
                if (!(ccActive?.campaign_customer_active_id > 0)) {
                    return;
                }

                // If null, reset back to empty array
                if (!this.campaignCustomers) {
                    this.campaignCustomers = [];
                }

                // If null, set to empty object
                if (!this.currentCampaignCustomer) {
                    this.currentCampaignCustomer = {};
                }

                // // Set fields on cc active pointer
                this.currentCampaignCustomer.campaign_customer_active_id = ccActive.campaign_customer_active_id;
                this.currentCampaignCustomer.account_id = ccActive.account_id;
                this.currentCampaignCustomer.assigned_to = ccActive.assigned_to;
                this.currentCampaignCustomer.campaign_customer_id = ccActive.campaign_customer_id;
                this.currentCampaignCustomer.campaign_id = ccActive.campaign_id;
                this.currentCampaignCustomer.current_scheduled_communication_id = ccActive.current_scheduled_communication_id;
                this.currentCampaignCustomer.customer_id = ccActive.customer_id;
                this.currentCampaignCustomer.customer_vehicle_id = ccActive.customer_vehicle_id;
                this.currentCampaignCustomer.forte_crm_key_id = ccActive.forte_crm_key_id;
                this.currentCampaignCustomer.gm_ro_bac_is_valid = ccActive.gm_ro_bac_is_valid;
                this.currentCampaignCustomer.inline_crm_key = ccActive.inline_crm_key;
                this.currentCampaignCustomer.next_attemptable_id = ccActive.next_attemptable_id;
                this.currentCampaignCustomer.next_attemptable_type = ccActive.next_attemptable_type;
                this.currentCampaignCustomer.noticeable_id = ccActive.noticeable_id;
                this.currentCampaignCustomer.noticeable_type = ccActive.noticeable_type;
                this.currentCampaignCustomer.organization_id = ccActive.organization_id;
                this.currentCampaignCustomer.organization_time_zone_id = ccActive.organization_time_zone_id;
                this.currentCampaignCustomer.account_forte_crm_enabled = ccActive.account_forte_crm_enabled;
                this.currentCampaignCustomer.account_inline_crm_enabled = ccActive.account_inline_crm_enabled;
                this.currentCampaignCustomer.campaign_name = ccActive.campaign_name;
                this.currentCampaignCustomer.enrolled_date = ccActive.enrolled_date;
                this.currentCampaignCustomer.expiration_code = ccActive.expiration_code;
                this.currentCampaignCustomer.next_attemptable_value = ccActive.next_attemptable_value;
                this.currentCampaignCustomer.next_attempt_number = ccActive.next_attempt_number;
                this.currentCampaignCustomer.organization_name = ccActive.organization_name;
                this.currentCampaignCustomer.prospect_id = ccActive.prospect_id;
                this.currentCampaignCustomer.purpose = ccActive.purpose;
                this.currentCampaignCustomer.status = ccActive.status;
                this.currentCampaignCustomer.total_communication_dispositions = ccActive.total_communication_dispositions;
                this.currentCampaignCustomer.mykaarma_enabled = this.resolveMykaarmaScreenPopEnabled(
                    ccActive.organization_id,
                    ccActive.mykaarma_enabled,
                );
                this.currentCampaignCustomer.tekion_enabled = ccActive.tekion_enabled;
                this.currentCampaignCustomer.toyoguard_enabled = ccActive.toyoguard_enabled;
                this.currentCampaignCustomer.user_email = ccActive.user_email;
                this.currentCampaignCustomer.user_first_name = ccActive.user_first_name;
                this.currentCampaignCustomer.user_last_name = ccActive.user_last_name;
                this.currentCampaignCustomer.conversation_group = ccActive.conversation_group;
                this.currentCampaignCustomer.customer = ccActive.customer;
                this.currentCampaignCustomer.vin_enabled = ccActive.vin_enabled;
                this.currentCampaignCustomer.is_integrations_api_calendar_ui_enabled = ccActive.is_integrations_api_calendar_ui_enabled;
                this.currentCampaignCustomer.xtime_enabled = ccActive.xtime_enabled;

                // Run only if we need to
                if (!skipStatusMove) {

                    // Move cc active into in progress
                    this.moveCampaignCustomerActiveToInProgress();
                }

                // Resize window
                Vue.nextTick(() => {
                    this.handleWindowResize();
                });
            },
            onCampaignCustomerActiveStatusChange(response) {

                // Verify legit cc
                const campaignCustomer = response?.Data;
                if (!(campaignCustomer?.campaign_customer_active_id > 0) || !(campaignCustomer?.account_id > 0) || !(campaignCustomer?.purpose?.length > 0) || !(campaignCustomer?.status?.length > 0)) {
                    return;
                }

                // Verify purpose is return message
                if (campaignCustomer.purpose !== "return_message") {
                    return;
                }

                // Only need to do something when status is "queued" or "completed" (12/1/2020)
                if (campaignCustomer.status !== "queued" && campaignCustomer.status !== "completed") {
                    return;
                }

                // If the current user is the one doing the updating, let the function response handlers control the flow
                if (this.isUpdatingCCActive) {
                    return;
                }

                // Verify current user has this cc active - otherwise no need to run handle
                // We don't want to run the handle for user's who don't need to
                if (!this.hasCampaignCustomerActive(campaignCustomer.campaign_customer_active_id)) {
                    return;
                }

                // Init
                const skipAgentCreateInForce = false;
                let skipAssignLoading = false;

                // Need to skip assign loading if the current user is the agent in the communication center and the record is not up on the agent's screen
                // If valid force is false, then the current user has to be in the communication center
                if (!this.validForceCampaignCustomer && this.currentCampaignCustomer?.campaign_customer_active_id > 0 && this.currentCampaignCustomer?.campaign_customer_active_id !== campaignCustomer.campaign_customer_active_id) {
                    skipAssignLoading = true;
                }

                this.handleAfterCampaignCustomerActive(campaignCustomer.campaign_customer_active_id, skipAgentCreateInForce, skipAssignLoading);
            },
            onNewAssignedCampaignCustomer(response) {

                // Verify legit cc
                const campaignCustomer = response?.Data;
                if (!(campaignCustomer?.campaign_customer_active_id > 0) || !(campaignCustomer?.account_id > 0) || !(campaignCustomer?.assigned_to > 0)) {
                    return;
                }

                // Verify assigned to is current user
                if (this.currentUser?.user_id !== campaignCustomer.assigned_to) {
                    return;
                }

                // Reinit if null
                if (this.campaignCustomers === null || this.campaignCustomers === undefined) {
                    this.campaignCustomers = [];
                }

                // Determine if record already is in array
                const idx = this.campaignCustomers.findIndex(i => i.campaign_customer_active_id === campaignCustomer.campaign_customer_active_id);
                if (idx >= 0) {
                    return;
                }

                // Push onto array
                this.campaignCustomers.push(campaignCustomer);

                // If this is the only campaign customer assigned to the user, promote to in progress
                if (this.campaignCustomers?.length === 1) {
                    this.changeCampaignCustomers(campaignCustomer);
                }
            },
            onNewCommunicationDisposition(response) {

                // Verify legit communication disposition
                const data = response?.Data;
                const communicationDisposition = data?.communication_disposition;
                if (!(communicationDisposition?.communication_disposition_id > 0) || !(communicationDisposition?.campaign_customer_active_id > 0) || !(communicationDisposition?.account_id > 0)) {
                    return;
                }

                // If force, then the current user is a manager and the current cc should match
                // Otherwise, need to check array of campaign customers
                if (this.validForceCampaignCustomer) {

                    // Verify the campaign customer is the same
                    if (this.currentCampaignCustomer?.campaign_customer_active_id !== communicationDisposition.campaign_customer_active_id) {
                        return;
                    }

                    applyIncomingTotalCommunicationDispositions(this.currentCampaignCustomer, data?.total_communication_dispositions);
                } else {

                    // Verify array has records
                    if (!(this.campaignCustomers?.length > 0)) {
                        return;
                    }

                    // Loop through
                    for (let i = 0; i < this.campaignCustomers.length; i++) {

                        // Init
                        const ccActive = this.campaignCustomers[i];

                        // Verify the campaign customer is the same and if so, set total
                        if (ccActive?.campaign_customer_active_id === communicationDisposition.campaign_customer_active_id) {
                            applyIncomingTotalCommunicationDispositions(ccActive, data?.total_communication_dispositions);
                            break;
                        }
                    }
                }
                if (this.currentCampaignCustomer?.conversation_group?.unresponded_to_incoming_message_id > 0) {
                    UpdateCommunicationResponseStatusForMessageUnresponded({
                        communication_response_status: "dispositioned_no_response",
                        eventable_id: communicationDisposition.communication_disposition_id,
                        eventable_type: "communication_disposition",
                        message_id: this.currentCampaignCustomer?.conversation_group?.unresponded_to_incoming_message_id,
                    }).then((response) => {
                        if (!response.Error) {
                            this.showSnackbar('var(--success)', 'Communication response status updated');
                            this.$emit('acknowledged-from-message-screen');
                            this.isAcknowledgeable = false;
                        } else {
                            // Acknowledgement failed silently before; surface it so the agent knows why the unresponded banner is still showing.
                            this.showSnackbar('var(--error)', response?.Error?.length > 0 ? response.Error : 'Unable to change communication response status');
                        }
                    });
                }
            },
            onNewMessage(response) {

                // Check if new message is a customer message and that we have assigned campaign customers
                const message = response?.Data;
                if (!message || !(message.account_id > 0) || !(message.message_id > 0) || !(message.conversation_group_id > 0) || (message.personable_type !== "customer_phone_number" && message.personable_type !== "twilio_number") || !(this.campaignCustomers?.length > 0)) {
                    return;
                }

                // Match to conversation group using assigned campaign customers
                const match = this.matchMessageToConversationGroup(message);

                // Abort if no matches
                if (!match) {
                    return;
                }

                // If match conversation has a message with an ID greater or equal to the
                // current message then this is a double and we should disregard this message
                if ((match.conversationGroup.last_message_id || 0) >= message.message_id) {
                    return;
                }

                // Play audio
                switch(message.direction) {
                case "incoming":
                    this.playIncomingMessageAudio();
                    break;
                case "outgoing":
                    this.playOutgoingMessageAudio();
                    break;
                }

                // Set new values on conversation group
                match.conversationGroup.last_conversation_id = message.conversation_id;
                match.conversationGroup.last_message_body = message.body;
                match.conversationGroup.last_message_id = message.message_id;
                match.conversationGroup.last_message_time = message.created_at;
                match.conversationGroup.last_sent_by = message.sent_by;
                match.conversationGroup.unresponded_to_incoming_message_at = message.unresponded_to_incoming_message_at;
                match.conversationGroup.unresponded_to_incoming_message_id = message.unresponded_to_incoming_message_id;

                // Set to empty array if null
                if (!(match.conversationGroup.unread_message_ids?.length > 0)) {
                    match.conversationGroup.unread_message_ids = [];
                }

                // Re-sort customers since we have a new message
                this.campaignCustomers = this.sortCampaignCustomersByLastMessageId(this.campaignCustomers);

                // If the message was incoming, append to array
                if (message.personable_type === "customer_phone_number") {

                    // Append message ID to unread message ID array and cleanup array
                    match.conversationGroup.unread_message_ids.push(message.message_id);
                    this.cleanupUnreadMessageIDs(match.conversationGroup);

                    // If the message matches the currently assigned campaign customer, mark as read
                    if (match.belongsToCurrentAssigned) {
                        this.readAllConversationGroupUnreadMessages(match.conversationGroup.conversation_group_id, match.conversationGroup.account_id)
                    }
                }

                return;
            },
            onReadReceipt(response) {

                // Check if new message is a customer message and that we have assigned campaign customers
                const message = response?.Data;
                if (!message || !(message.account_id > 0) || !(message.message_id > 0) || !(message.conversation_group_id > 0) || !(this.campaignCustomers?.length > 0)) {
                    return;
                }

                // Match to conversation group using assigned campaign customers
                const match = this.matchMessageToConversationGroup(message);

                // Abort if no matches
                if (!match) {
                    return;
                }

                // Abort if matched conversation group does not have any unread messages
                if (!(match.conversationGroup.unread_message_ids?.length > 0)) {
                    return;
                }

                // Loop over messages
                for (let i = 0; i < match.conversationGroup.unread_message_ids.length; i++) {

                    // Init
                    const messageID = match.conversationGroup.unread_message_ids[i];

                    // If conversation group and message ID is less than or equal to push message's ID
                    if ((messageID || 0) <= message.message_id) {

                        // Remove from array
                        match.conversationGroup.unread_message_ids.splice(i, 1);

                        // Decrease i since we removed record from array
                        i -= 1;
                    }
                }

                return;
            },
            onRequeuedIdleCampaignCustomerActive(response) {

                // Verify legit cc
                const campaignCustomer = response?.Data;
                if (!(campaignCustomer?.campaign_customer_active_id > 0) || !(campaignCustomer?.account_id > 0)) {
                    return;
                }

                // Verify user has campaign customers
                if (!(this.campaignCustomers?.length > 0)) {
                    return;
                }

                // Determine if record is in array
                const idx = this.campaignCustomers.findIndex(i => i.campaign_customer_active_id === campaignCustomer.campaign_customer_active_id);
                if (idx < 0) {
                    return;
                }

                // Remove from array
                this.campaignCustomers.splice(idx, 1);

                // If the record is the assigned record, unassign
                if (this.currentCampaignCustomer?.campaign_customer_active_id === campaignCustomer.campaign_customer_active_id) {
                    this.currentCampaignCustomer = null;
                }

                // Move user to Pause
                this.createAgentForPause();
            },
            pauseMessageAudios() {
                // Pause in case they are running - otherwise they won't be destroyed properly
                if (!!this.incomingMessageAudio) {
                    this.incomingMessageAudio.pause();
                }
                if (!!this.outgoingMessageAudio) {
                    this.outgoingMessageAudio.pause();
                }
            },
            playIncomingMessageAudio() {
                if (this.userDomInteraction === true && !!this.incomingMessageAudio && this.currentUser?.account_user?.incoming_message_audio_enabled === true) {
                    this.incomingMessageAudio.play().catch(() => {});
                }
            },
            playOutgoingMessageAudio() {
                if (this.userDomInteraction === true && !!this.outgoingMessageAudio && this.currentUser?.account_user?.outgoing_message_audio_enabled === true) {
                    this.outgoingMessageAudio.play().catch(() => {});
                }
            },
            readAllConversationGroupUnreadMessages(conversationGroupID, accountID) {
                const options = {
                    account_id: accountID,
                    conversation_group_id: conversationGroupID,
                }

                ReadAllConversationGroupUnreadMessages(options).then(() => {
                });

                return;
            },
            resetCurrentCampaignCustomerDefaults(enrollmentSkip) {
                this.communicationManager = null;
                this.initiateCreateCommunicationDisposition = false;
                this.isUpdatingCCActive = false;
                this.mainErrorAlert = {};

                // Enrollment skip
                if (!enrollmentSkip) {
                    this.isOkayToCreateCommunicationDisposition = false;
                    this.selectedCampaignDisposition = null;
                }
            },
            resyncScreenForInternetLoss() {

                // Reload assign ready campaign customers
                this.assignReadyCampaignCustomers(true);
            },
            setAppointmentIsUniqueIfRequired(value) {
                this.appointmentIsUniqueIfRequired = value;
            },
            setChangeOnCurrentCampaignCustomer(key, value) {
                switch(key) {
                case "total_communication_dispositions":
                    applyIncomingTotalCommunicationDispositions(this.currentCampaignCustomer, value);
                }
            },
            setCommunicationManager(communicationManager) {
                this.communicationManager = communicationManager;
            },
            setIsOkayToCreateCommunicationDisposition(isOkayToCreateCommunicationDisposition) {
                this.isOkayToCreateCommunicationDisposition = isOkayToCreateCommunicationDisposition === true ? true : false;
            },
            setSelectedCampaignDisposition(campaignDisposition) {
                this.selectedCampaignDisposition = campaignDisposition;
            },
            sortCampaignCustomersByLastMessageId(campaignCustomers) {
                if (!(!!campaignCustomers && campaignCustomers.length > 0)) {
                    return [];
                }

                return campaignCustomers.sort(function(x, y){
                    return y?.conversation_group?.last_message_id - x?.conversation_group?.last_message_id;
                });
            },
            unassignCampaignCustomerActive() {

                // Init options
                const options = {
                    campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id,
                    account_id: this.currentCampaignCustomer?.account_id,
                    status: "queued",
                }

                // Update record in db
                this.updateCampaignCustomerActive(options);
            },
            updateCampaignCustomerActive(options) {
                this.isLoading = true;
                this.isUpdatingCCActive = true;
                UpdateCampaignCustomerActive(options).then((response) => {

                    // If the response's campaign customer active matches the current record, set changes
                    if (response?.Data?.campaign_customer_active?.id > 0 && response?.Data?.campaign_customer_active?.id === this.currentCampaignCustomer?.campaign_customer_active_id) {
                        this.currentCampaignCustomer.status = response.Data.campaign_customer_active.status;

                        // Switch over status
                        switch(this.currentCampaignCustomer.status) {

                        // If record is now completed, null current and rerun assign ready campaign customers
                        case "completed":
                            this.createAgentForCompletedCustomer();
                            this.handleAfterCampaignCustomerActive(this.currentCampaignCustomer.campaign_customer_active_id, true, false);
                            break;

                        // If this record is now in progress, loop through other records and set back to assigned
                        case "in_progress":
                            this.createAgentForJoinedConversation();
                            this.ensureOtherCampaignCustomersBackToAssigned();
                            break;

                        // If the record is now queued, record was "saved for later", null current and rerun assign ready cc
                        case "queued":
                            this.createAgentForSavedForLater();
                            this.handleAfterCampaignCustomerActive(this.currentCampaignCustomer.campaign_customer_active_id, true, false);
                            break;

                        }
                    }

                    this.isLoading = false;
                    this.isUpdatingCCActive = false;
                });
            },
            updateCommunicationResponseStatusForMessageUnresponded(messageId) {
                this.isUpdateCommunicationResponseStatusLoading = true;
                
                const options = {
                    eventable_id: this.currentUser?.user_id || 0,
                    eventable_type: "user",
                    communication_response_status: "acknowledged_no_response",
                    message_id: messageId,
                }

                UpdateCommunicationResponseStatusForMessageUnresponded(options).then((response) => {
                    if (!response.Error) {
                        this.showSnackbar('var(--success)', 'Communication response status updated');
                        this.$emit('acknowledged-from-message-screen');
                        this.isAcknowledgeable = false;
                    } else {
                        this.showSnackbar('var(--error)', 'Unable to change communication response status');
                    }
                }).finally(() => {
                    this.isUpdateCommunicationResponseStatusLoading = false;
                });
            },
        },
        computed: {
            assignedHasUnreadMessages() {
                return (this.currentCampaignCustomer?.conversation_group?.conversation_group_id > 0 && this.currentCampaignCustomer?.conversation_group?.account_id > 0 && (this.currentCampaignCustomer?.conversation_group?.unread_message_ids || []).length > 0);
            },
            currentUser() {
                return VolieState.currentUser();
            },
            renderNoCurrentCustomer() {

                // If loading, do not render
                if (this.isLoading) {
                    return false;
                }

                // If manual mode but missing campaign ID, render. Otherwise render if missing cc active ID
                return this.isManualMode ? !this.validCampaignID : (!this.validCampaignCustomerActiveID && !this.isLoading);
            },
            renderNoLoggedInQueues() {
                return !this.hasLoggedInQueues && !this.validForceCampaignCustomer;
            },
            userDomInteraction() {
                return VolieState.userDomInteraction();
            },
            validCampaignCustomerActiveID() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validCampaignID() {
                return this.currentCampaignCustomer?.campaign_id > 0;
            },
            validEndForceCustomer() {
                return this.endForceCustomer !== undefined && this.endForceCustomer !== null;
            },
            validForceCampaignCustomer() {
                return this.forceCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validForceCustomer() {
                return this.forceCustomer?.customer_id > 0;
            },
        },
        components: {
            AssignedSummary,
            CustomerProfile,
            CustomerSearchCreate,
            NoCurrentCustomer,
            NoLoggedInQueues,
            Softphone,
        },
        props: {
            audioEmailIncoming: HTMLAudioElement,
            audioEmailOutcoming: HTMLAudioElement,
            createAgent: Function,
            endForceCustomer: Function,
            exitForceCampaignCustomer: Function,
            forceCampaign: Object,
            forceCampaignCustomer: Object,
            forceCustomer: Object,
            getCommunicationCenter: Function,
            hasLoggedInQueues: Boolean,
            isRacOnline: Boolean,
            isVinEnabled: Boolean,
            organizationUsers: Array,
            resolveMykaarmaScreenPopEnabled: {
                type: Function,
                default: (_organizationId, serverEnabled) => serverEnabled === true,
            },
            setSmsMessageTotalAssignedUnrespondedToCustomers: Function,
            showSnackbar: Function,
        },
        destroyed() {
            this.pauseMessageAudios();
            window.removeEventListener('resize', this.handleWindowResize);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "campaignCustomerActiveStatusChange" }}, this.onCampaignCustomerActiveStatusChange);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "customerAndIncomingPhoneNumberMessageReadReceipt" }}, this.onReadReceipt);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newAssignedCampaignCustomer" }}, this.onNewAssignedCampaignCustomer);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newCommunicationDisposition" }}, this.onNewCommunicationDisposition);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newCustomerAndIncomingPhoneNumberMessage" }}, this.onNewMessage);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "requeuedIdleCampaignCustomerActive" }}, this.onRequeuedIdleCampaignCustomerActive);
            return;
        },
        created() {
            this.loadMessageAudios();
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "campaignCustomerActiveStatusChange" }}, this.onCampaignCustomerActiveStatusChange);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "customerAndIncomingPhoneNumberMessageReadReceipt" }}, this.onReadReceipt);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newAssignedCampaignCustomer" }}, this.onNewAssignedCampaignCustomer);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newCommunicationDisposition" }}, this.onNewCommunicationDisposition);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newCustomerAndIncomingPhoneNumberMessage" }}, this.onNewMessage);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "requeuedIdleCampaignCustomerActive" }}, this.onRequeuedIdleCampaignCustomerActive);
            this.initMainErrorAlert();

           
                // If we have logged in queues, execute immediately
                this.executeRemainingCreatedActions();
        },
        mounted() {
            window.addEventListener('resize', this.handleWindowResize);
            this.handleWindowResize();
        },
        watch: {
            forceCampaign: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceCampaign?.campaign_id > 0) {
                        this.enterManualMode({ ...this.forceCampaign });
                    }
                },
            },
            hasLoggedInQueues: {
                deep: true,
                immediate: true,
                handler(newValue, oldValue) {
                    if (oldValue !== newValue && newValue === true && oldValue === false && !this.validForceCampaignCustomer) {
                        this.initMainErrorAlert();
                        this.executeRemainingCreatedActions();
                    }
                },
            },
            currentCampaignCustomer: {
                deep: true,
                immediate: true,
                handler(newVal) {
                    if (newVal?.conversation_group?.communication_response_status === 'unresponded') {
                        this.isAcknowledgeable = true;
                    } else if (newVal?.total_communication_dispositions > 0) {
                        this.isAcknowledgeable = false;
                    }
                    this.$forceUpdate();
                },
            },
            isLoading() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
            isRacOnline() {

                // If it changed and now is true again, need to re-sync their assigned customers and cc deployments in case they missed some realtime requests
                if (this.isRacOnline === true) {
                    this.resyncScreenForInternetLoss()
                }
            },
        },
    });
</script>

<style lang="scss" scoped>
</style>
